export default [
  {
    path: '/settings',
    name: 'user-settings',
    component: () => import('@/modules/home/_views/Home.vue')
  }
]
